;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { InlineNotification } from '@qogita/ui/v2/inline-notification'
import { useFormContext } from 'react-hook-form'

export function FormRootErrorMessage() {
  const form = useFormContext()
  if (!form.formState.errors.root) {
    return null
  }
  return (
    <InlineNotification
      theme="error"
      emphasis="low"
      data-testid="form-root-error-message"
      message={form.formState.errors.root.message}
    />
  )
}
